import { Box, Typography } from "@mui/material";
import { PricePlan, SwitchButton } from "./LandingPageElements";
import { useState } from "react";
import { pricingData } from "../../utils/data/Landing-Page/data";



export const FifthPage = () => {
    const [price, setPrice] = useState(3);
    return (
        <Box sx={{ background: '#fff' }}>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', textAlign: 'center', alignItems: 'center', width: '80%', py: 3 }}>
                    <Typography sx={{ fontSize: '20px', color: '#0057D5', fontWeight: '700', py: 4 }}>PRICING</Typography>
                    <Typography sx={{ fontSize: '40px', color: '#040815', fontWeight: '700', py: 2 }}>Flexible Pricing Plans to Suit Your Needs</Typography>
                    <Typography sx={{ fontSize: '20px', color: '#474747', fontWeight: '500', py: 2 }}>Our options are designed for both small teams and large enterprises.</Typography>
                    <SwitchButton />
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', my: 4 }}>
                        {pricingData.map((e, i) => (<PricePlan key={i} data={e} setPrice={setPrice} i={i} black={price === i} />))}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}